var map = {
	"./activities/list.svg": "578d",
	"./activities/map-pin.svg": "1f20",
	"./activities/payment.svg": "7d43",
	"./activities/plus.svg": "61dd",
	"./activities/user.svg": "a579",
	"./arrow-right.svg": "3f8a",
	"./attachments/csv.svg": "a1bf",
	"./attachments/doc.svg": "d053",
	"./attachments/pdf.svg": "d365",
	"./bad.svg": "e0ca",
	"./beauty.svg": "a683",
	"./calculator.svg": "b643",
	"./cards/flutterwave.png": "4a95",
	"./cards/mastercard.svg": "5603",
	"./cards/paystack.png": "5a34",
	"./cards/verve.svg": "d7be",
	"./cards/visa.svg": "bbb1",
	"./carebox.svg": "ca89",
	"./checkbox-circle.svg": "0250",
	"./checkbox.svg": "551a",
	"./cleaning.svg": "a4b0",
	"./default-avatar.svg": "ab4a",
	"./default/image-upload-icon.svg": "4afa",
	"./eden_logo.svg": "b932",
	"./eden_logo_icon.svg": "f342",
	"./empty-page.svg": "4cc0",
	"./expand-stat.svg": "d965",
	"./external-link.svg": "6d02",
	"./flags/KE.svg": "a01b",
	"./flags/NG.svg": "4efd",
	"./good.svg": "0d3a",
	"./laundry.svg": "d112",
	"./meal.svg": "ff4a",
	"./negative.svg": "efe4",
	"./positive.svg": "c583",
	"./profile-avatar.svg": "18f3",
	"./services/beauty.png": "a8fa",
	"./services/cleaning.png": "a72f",
	"./services/dailymeal.png": "8b2f",
	"./services/laundry.png": "b97e",
	"./services/meal.png": "2fe0",
	"./user.svg": "f41a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";